import {
    post
} from './request'

// 咨询答复列表
export const getZixundafuPage = data => post('/index/zx_list', data)
// 咨询答复详情
export const getZixundafuOne = data => post('/index/zx_detail', data)
// 网上咨询--信息提交 
export const postWangshangzixun = data => post('/index/zx', data)